import { inject, observer } from 'mobx-react';
import * as React from 'react';
import LanguageStore from '../../stores/LanguageStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { localizeClockHourAndMinuteSeparator } from '../../util/TimeUtil';
import { BusinessHour, SpecialHour } from '../common/ReservationInterfaces';

interface BranchOpenTimeProps {
  languageStore?: LanguageStore;
  displayOpenText: boolean;
  hour: SpecialHour | BusinessHour;
}

@observer
class BranchOpenTime extends React.Component<BranchOpenTimeProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const {
      hour,
      displayOpenText,
      languageStore: { currentLanguage }
    } = this.props;

    return hour.closed ? (
      <span> {translate('branch.closed')}</span>
    ) : (
      <span>
        {displayOpenText && translate('branch.open')} {localizeClockHourAndMinuteSeparator(hour.openTime, currentLanguage)}–
        {localizeClockHourAndMinuteSeparator(hour.closeTime, currentLanguage)}
      </span>
    );
  }
}

export default inject('languageStore')(BranchOpenTime);
